// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"16305f1b","213":"6c670eab","239":"37026019","732":"7aeb1cf4"}[chunkId] + ".chunk.js";
};